import React from 'react'
import { AnimatePresence, motion } from 'framer-motion'

import useConfirmation from 'containers/confirmation/useConfirmation'

import 'css/PopUp.scss'

const ConfirmationMessage = () => {
  const { message, confirmLabel, visible, onConfirm, onCancel } = useConfirmation()

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
          exit={{ opacity: 0 }}
          className={`pop-up confirmation-pop-up`}
          id="pop-up"
        >
          <div className="text-container">
            {/* pre-line: multi-paragraph messages (e.g. the Shopify store-switch prompt) use
                \n\n for paragraph breaks. Long-form messages — multi-line strings and rich
                ReactNode messages — also drop the bold heading weight — a wall of 700-weight
                text is unreadable; short string confirms keep their look. */}
            <span
              className="text"
              style={
                typeof message !== 'string' || message.includes('\n')
                  ? { whiteSpace: 'pre-line', fontWeight: 400 }
                  : undefined
              }
            >
              {message}
            </span>
          </div>
          <div
            className="confirmation-actions"
            style={{ display: 'flex', flexDirection: 'row' }}
          >
            <button onClick={onCancel} className="cancel-button">
              Cancel
            </button>{' '}
            <button className="submit-button" onClick={onConfirm}>
              {confirmLabel || 'Confirm'}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default React.memo(ConfirmationMessage)
